import { notNull } from "@/utils/helpers";

// DEFAULT_IGNORE_ERRORS from @sentry/core 10.76.2 integrations/eventFilters (MIT), so Datadog drops what Sentry drops.
const IGNORED_BROWSER_ERROR_PATTERNS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/,
  /^Can't find variable: gmo$/,
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  /can't redefine non-configurable property "solana"/,
  /vv\(\)\.getRestrictions is not a function/,
  /Can't find variable: _AutofillCallbackHandler/,
  /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
  /Java exception was raised during method invocation$/,
  /Java object is gone$/,
];

// Sentry tests both the bare message and `${type}: ${message}`.
export const isIgnoredBrowserError = ({
  name,
  message,
}: {
  name?: string;
  message?: string;
}): boolean => {
  if (!message) return false;
  const candidates = notNull(name)
    ? [message, `${name}: ${message}`]
    : [message];
  return candidates.some((candidate) =>
    IGNORED_BROWSER_ERROR_PATTERNS.some((pattern) => pattern.test(candidate))
  );
};
